import React, { useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import { handleUserLevelAccessPermissions, changeDateFormat } from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { API_URL } from '../../../../Constant';
import messages from '../.././../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import { iipMiningReport, iipMiningReportCombined } from '../../../../Custom/IIPReport/Report/ReportExcel';

function IIPElectricityReport() {

    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const [isDivision, setIsDivision] = useState(false);
    const [years, setYears] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [reportRows, setReportRows] = useState([]);
    const [reportMonths, setReportMonths] = useState([]);
    const [buttonAccess, setButtonAccess] = useState(false);
    const storedLanguage = localStorage.getItem('language');
    const navigate = useNavigate();
    const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const MONTH_SHORT = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    

useEffect(() => {

  const level = handleUserLevelAccessPermissions(decode_token);
  setButtonAccess(level)
  if(level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
    setIsDivision(true);
    }

  const startYear = 2014;
  const endYear = new Date().getFullYear();
  const yearsArray = [];
  for (let y = endYear; y >= startYear; y--) yearsArray.push(y);
  setYears(yearsArray);

  }, []);

  const FUTURE_MONTH_YEAR_MSG = 'Please select a valid month and year';

  const isFutureMonthYear = (monthIndex, yearVal) => {
    if (monthIndex === '' || monthIndex === null || monthIndex === undefined || yearVal === '' || yearVal === null || yearVal === undefined) {
      return false;
    }
    const y = Number(yearVal);
    const m = Number(monthIndex);
    if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
    const now = new Date();
    const cy = now.getFullYear();
    const cm = now.getMonth();
    if (y > cy) return true;
    if (y < cy) return false;
    return m > cm;
  };

  const handleMonthChange = (e) => {
    const raw = e.target.value;
    const newMonth = raw === '' ? '' : Number(raw);
    if (newMonth !== '' && selectedYear !== '' && isFutureMonthYear(newMonth, selectedYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedMonth(newMonth);
  };

  const handleYearChange = (e) => {
    const raw = e.target.value;
    const newYear = raw === '' ? '' : Number(raw);
    if (selectedMonth !== '' && newYear !== '' && isFutureMonthYear(selectedMonth, newYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    setSelectedYear(newYear);
  };

  const parseNumeric = (val) => {
    if (val === null || val === undefined || val === '') return null;
    const n = Number(val);
    return Number.isFinite(n) ? n : null;
  };

  const getVariationMeta = (currentCell, referenceCell) => {
    const currentIndex = parseNumeric(currentCell?.['Index(I)']);
    const referenceIndex = parseNumeric(referenceCell?.['Index(I)']);
    if (currentIndex === null || referenceIndex === null) return { text: '', value: null };

    let variation = 0;
    if (referenceIndex === 0) {
      variation = currentIndex === 0 ? 0 : 100;
    } else {
      variation = ((currentIndex - referenceIndex) / referenceIndex) * 100;
    }

    return {
      text: `${variation.toFixed(2)}%`,
      value: variation,
    };
  };

  /** API rows -> Mining table jaisa shape (month keys -> cell object) */
  const buildElectricityDisplayRows = (formattedData, months) => {
    if (!Array.isArray(formattedData) || !months?.length) return [];
    return formattedData.map((item) => {
      const row = {
        'Industry and Item': item.Industry_and_Item,
        Weight: item.Weight,
        Units: item.Units,
      };
      months.forEach((m) => {
        const rec = (item.Monthly_Data || []).find((x) => x.Month === m) || {};
        row[m] = {
          'B.P.2011-12(Qty)': rec.BP_2011_12_Qty ?? '',
          'C.P.(Qty)': rec.CP_Qty ?? '',
          'Index(I)': rec.Index_I ?? '',
          'Index* Wt (IW)': rec.Index_Wt_IW ?? '',
        };
      });
      return row;
    });
  };

//handle excel sheet ***************
const handleGenerateExcel = () => {
    if (selectedMonth === '' || selectedYear === '') {
      toast.error('Please select month and year', messages.COLOR_RED);
      return;
    }
    if (isFutureMonthYear(selectedMonth, selectedYear)) {
      toast.error(FUTURE_MONTH_YEAR_MSG, messages.COLOR_RED);
      return;
    }
    
    showLoading(true);
    const month = MONTH_SHORT[Number(selectedMonth)];
    const year = String(selectedYear);
    const payload = {
      month,
      year,
    };
    
    // POST request to API
    axios
      .post(`${API_URL}api/iipReports/HQReports/IIPElectricitySector`, payload, config)
      .then( async (response) => {
        const respData = response.data?.data || {};

        const currentData = respData.formattedData || [];
        const currentMonths = respData.monthArray || [];
        const currentPayload = respData.payload || payload;

        const previousData = respData.formattedDataPrevious || [];
        const previousMonths = respData.monthArrayPrevious || [];
        const previousPayload = respData.payloadPrevious || null;

        // On-page table (Mining report jaisa): current period prefer, warna previous
        if (currentData.length && currentMonths.length) {
          setReportRows(buildElectricityDisplayRows(currentData, currentMonths));
          setReportMonths(currentMonths);
        } else if (previousData.length && previousMonths.length) {
          setReportRows(buildElectricityDisplayRows(previousData, previousMonths));
          setReportMonths(previousMonths);
        } else {
          setReportRows([]);
          setReportMonths([]);
        }

        // Dono available hon to combined Excel (Current upar, Previous neeche)
        if (currentData.length && currentMonths.length && previousData.length && previousMonths.length && previousPayload) {
          const currentBlock = buildElectricityBlock(currentData, currentMonths);
          const previousBlock = buildElectricityBlock(previousData, previousMonths);

          const headingYear = currentPayload?.month && currentPayload?.year
            ? `${currentPayload.month} ${currentPayload.year}`
            : currentMonths[0];

          const excelObjectData = {
            firstRowExportDate: changeDateFormat(new Date()),
            secondRowText: 'ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH',
            thirdRowText: 'COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P  (Base Year 2011-12)',
            fourthRowTextCurrent: `ELECTRICITY SECTOR (${headingYear})`,
            current: currentBlock,
            previous: previousBlock,
            reportName: 'ELECTRICITY SECTOR',
            fileName: `ElectricityReport_Combined(${headingYear})`,
            fileType: 'xls',
            sheetName: 'ELECTRICITY SECTOR',
          };
          await iipMiningReportCombined(excelObjectData);
        } else if (currentData.length && currentMonths.length) {
          // Sirf current period ka data available
          await downloadExcelReport(currentData, currentPayload, currentMonths);
        } else if (previousData.length && previousMonths.length && previousPayload) {
          // Sirf previous year ka data available
          await downloadExcelReport(previousData, previousPayload, previousMonths);
        } else {
          setReportRows([]);
          setReportMonths([]);
          toast.info('No data found for the selected period.', messages.COLOR_RED);
        }

        showLoading(false);
      })
      .catch((error) => {
        // Handle error if needed
        console.error('API Error:', error);
        showLoading(false);
      });
  };
     


const getMappedData = (monthlyData, months) => {
  const parseNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  const getVariationFromCurrent = (currentRec, refRec) => {
    const currentIndex = parseNum(currentRec?.Index_I);
    const refIndex = parseNum(refRec?.Index_I);
    if (currentIndex === null || refIndex === null) return '';
    if (refIndex === 0) return currentIndex === 0 ? '0.00%' : '100.00%';
    return `${(((currentIndex - refIndex) / refIndex) * 100).toFixed(2)}%`;
  };

  const result = [];
  const currentMonth = months[0];
  const currentRec = (monthlyData || []).find((x) => x.Month === currentMonth) || {};
  months.forEach((m) => {
    const rec = (monthlyData || []).find((x) => x.Month === m) || {};
    if (m === currentMonth) {
      result.push(
        rec.BP_2011_12_Qty ?? '',
        rec.CP_Qty ?? '',
        rec.Index_I ?? '',
        rec.Index_Wt_IW ?? ''
      );
    } else {
      result.push(
        rec.BP_2011_12_Qty ?? '',
        rec.CP_Qty ?? '',
        rec.Index_I ?? '',
        rec.Index_Wt_IW ?? '',
        getVariationFromCurrent(currentRec, rec)
      );
    }
  });
  return result;
};


function capitalizeFirstChar(text) {
  if (!text) return ''; // Return empty string for falsy values
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

// local helper: 0-based column index -> Excel letter
function getColumnLetterLocal(colIndex) {
  let s = '';
  let n = colIndex + 1;
  while (n > 0) {
    const r = (n - 1) % 26;
    s = String.fromCharCode(65 + r) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
}


// Single-period Excel (sirf current ya sirf previous ke liye)
const downloadExcelReport = async (generalElectricityReportData, payload, year) => {
  const modifiedArray = year.flatMap((item, idx) => (idx === 0 ? [item, '', '', ''] : [item, '', '', '', '']));
  const yearColumn = ['Industry and Item ( with code)', 'Weight', 'Units', ...modifiedArray];
  const col = [];
  for (let i = 0; i < year.length; i++) {
    if (i === 0) {
      col.push(
        'B.P.2011-12(Qty)',
        'C.P.(Qty)',
        'Index(I)',
        'Index* Wt (IW)'
      );
    } else {
      col.push(
        'B.P.2011-12(Qty)',
        'C.P.(Qty)',
        'Index(I)',
        'Index* Wt (IW)',
        'Variation %'
      );
    }
  }

  const transformedData = generalElectricityReportData.map(item => [
    item['Industry_and_Item'],
    item.Weight,
    item.Units,
    ...getMappedData(item.Monthly_Data, year)
  ]);

  let heading_Year = year[0];
  if (payload?.month && payload?.year) {
    heading_Year = `${payload.month} ${payload.year}`;
  } else if (payload?.fromDate && payload?.toDate && payload.fromDate === payload.toDate) {
    heading_Year = `${capitalizeFirstChar(payload.fromDate)}-${capitalizeFirstChar(payload.toDate)}`;
  }
  const totalCols = Array.isArray(yearColumn) ? yearColumn.length : 7;
  const lastColLetter = getColumnLetterLocal(Math.max(1, totalCols) - 1);

  const excelObjectData = {
    reportName:'ELECTRICITY SECTOR',
    mergeRow: year.length,
    fileName: `ElectricityReport(${heading_Year})`,
    fileType: 'xls',
    sheetName: 'ELECTRICITY SECTOR',
    firstRowMergeCells: `A1:${lastColLetter}1`,
    firstRowExportDate:  changeDateFormat(new Date()),
    secondRowMergeCells: `A2:${lastColLetter}2`,
    secondRowText: `ECONOMICS & STATISTICS DIVISION, UTTAR PRADESH`,
    thirdRowMergeCells: `A3:${lastColLetter}3`,
    thirdRowText: `COMPUTATION OF INDUSTRIAL PRODUCTION INDEX  U.P  (Base Year 2011-12)`,
    fourthRowMergeCells: `A4:${lastColLetter}4`,
    fourthRowText: `ELECTRICITY SECTOR (${heading_Year})`,
    fromDate: heading_Year,
    toDate: heading_Year,
    yearColumn,
    headerEnglishColumns: ['', '', '', ...col],
    excelRowData: transformedData,
    monthGroupSizes: year.map((_, idx) => (idx === 0 ? 4 : 5)),
  };

  await iipMiningReport(excelObjectData);
};

// Block builder for combined (current + previous) report
const buildElectricityBlock = (formattedData, months) => {
  const modifiedArray = months.flatMap((item, idx) => (idx === 0 ? [item, '', '', ''] : [item, '', '', '', '']));
  const yearColumn = ['Industry and Item ( with code)', 'Weight', 'Units', ...modifiedArray];
  const col = [];
  for (let i = 0; i < months.length; i++) {
    if (i === 0) {
      col.push(
        'B.P.2011-12(Qty)',
        'C.P.(Qty)',
        'Index(I)',
        'Index* Wt (IW)'
      );
    } else {
      col.push(
        'B.P.2011-12(Qty)',
        'C.P.(Qty)',
        'Index(I)',
        'Index* Wt (IW)',
        'Variation %'
      );
    }
  }

  const excelRowData = (formattedData || []).map(item => [
    item['Industry_and_Item'],
    item.Weight,
    item.Units,
    ...getMappedData(item.Monthly_Data, months)
  ]);

  return {
    yearColumn,
    headerEnglishColumns: ['', '', '', ...col],
    excelRowData,
    mergeRow: months.length,
    monthGroupSizes: months.map((_, idx) => (idx === 0 ? 4 : 5)),
  };
};

  return (
    <>
   <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
            <h4 className="page_heading">
              <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? titlesData.hi.ElectricitySectorReport : titlesData.en.ElectricitySectorReport }} />
           </h4>
            <div className="row align-items-center">
              {isDivision && (
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                  <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                </div>
              )}



              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>Month</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedMonth}
                  onChange={handleMonthChange}
                >
                  <option value="">Select month</option>
                  {MONTH_NAMES.map((name, index) => (
                    <option key={index} value={index}>{name}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedYear}
                  onChange={handleYearChange}
                >
                  <option value="">Select year</option>
                  {years.length > 0 ? years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  )) : (
                    <option value={selectedYear}>{selectedYear}</option>
                  )}
                </select>
              </div>


              <div className="col-xl-2 col-lg-4 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
              </div>
            </div>


          </div>
        </div>
      </div>

        {/* Same layout as Mining report: table + Variation % (Index(I) based) */}
        {reportRows.length > 0 && reportMonths.length > 0 && (
          <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Industry and Item</th>
                      <th>Weight</th>
                      <th>Units</th>
                      {reportMonths.map((m, mi) => (
                        <th key={m} colSpan={mi === 0 ? 4 : 5} className="text-center align-middle">{m}</th>
                      ))}
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      {reportMonths.map((m, mi) => (
                        <React.Fragment key={`${m}-sub`}>
                          <th>B.P.(Qty)</th>
                          <th>C.P.(Qty)</th>
                          <th>Index(I)</th>
                          <th>Index*Wt(IW)</th>
                          {mi !== 0 && (
                            <th>Variation %</th>
                          )}
                        </React.Fragment>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {reportRows.map((row, idx) => {
                      const isSector = row['Industry and Item'] === 'ELECTRICITY SECTOR' || row['Industry and Item'] === 'MINING SECTOR';
                      return (
                        <tr key={`${row['Industry and Item']}-${idx}`}>
                          <td>{row['Industry and Item']}</td>
                          <td>{row.Weight}</td>
                          <td>{row.Units}</td>
                          {reportMonths.flatMap((m, mi) => {
                            const cell = row[m] || {};
                            const currentCell = row[reportMonths[0]] || {};
                            const baseCells = ([
                              <td key={`${idx}-${m}-bp`}>{isSector ? '' : (cell['B.P.2011-12(Qty)'] ?? '')}</td>,
                              <td key={`${idx}-${m}-cp`}>{isSector ? '' : (cell['C.P.(Qty)'] ?? '')}</td>,
                              <td key={`${idx}-${m}-i`}>{cell['Index(I)'] ?? ''}</td>,
                              <td key={`${idx}-${m}-iw`}>{cell['Index* Wt (IW)'] ?? ''}</td>,
                            ]);
                            if (mi !== 0) {
                              const varMeta = getVariationMeta(currentCell, cell);
                            const v = varMeta.value;
                            const eps = 1e-9;
                            const isZero = v !== null && Math.abs(v) < eps;
                            const arrow = isZero ? '' : (v > 0 ? '▲ ' : '▼ ');
                            const color =
                              v === null ? '' : isZero ? 'blue' : (v > 0 ? 'green' : 'red');
                              baseCells.push(
                              <td
                                key={`${idx}-${m}-var`}
                                style={{ color, fontWeight: v === null ? 'normal' : 600 }}
                              >
                                  {varMeta.text ? `${arrow}${varMeta.text}` : ''}
                                </td>
                              );
                            }
                            return baseCells;
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
    </div>
  </>
  )
}

export default IIPElectricityReport